export function capitalizeFirstLetter(value?: string) {
  if (!value) return '';
  return value.charAt(0).toUpperCase() + value.slice(1);
}

export const formataNumberStrToFloat = (
  value: string,
  decimal?: number,
): number => {
  const cleanedValue = value.replace('.', '').replace('R$', '');
  const normalizedValue = cleanedValue.replace(',', '.').trim();
  const numberValue = Number(normalizedValue);

  return decimal !== undefined
    ? Number(numberValue.toFixed(decimal))
    : numberValue;
};
